define('core/UI',[
	'jQuery',
	'core/helper/LocalStorageCss',
	'core/helper/LoadCss',
], function ($, lscss, LoadCss) {
	'use strict';

	var _debug = false;

	// IE8 has Problems with loading the font, so we had to specify this in the head via some conditional comments :/
	// @FIXME: find a nicer way
	if (! /MSIE ?8/i.test(navigator.userAgent)) {
		// DO NOT MOVE THIS!
		lscss.loadFont('iconfont');
		// lscss.loadFont('UniversLTPro');
	}


	var initializedContexts = [];
	var module = {};

	var ParsleyConfig = window.ParsleyConfig || (window.ParsleyConfig = {});
	ParsleyConfig.autoBind = false;

	// selector to Module conversion
	module.selectorToModule = {
		'[data-rel^="lightbox"], [rel^="lightbox"]': {
			moduleName: 'Lightbox',
			// priority is set to `low` by default
			// priority: 'low',
		},
		//'html': {
		// 	moduleName: 'ToTop',
		//},
		'.scroll-to': {
			moduleName: 'ScrollTo',
		},
		// '[data-toggle="tooltip"]': {
		// 	moduleName: 'Tooltip',
		// },
		'select, ul.select2-like': {
			moduleName: 'forms/Select'
		},
		// '.fancy-hover': {
		// 	moduleName: 'content/FancyHover'
		// },
		'.fullwidth-container > .fullwidth-container--inner > .row.no-padding': {
			moduleName: 'content/TilesReadmore',
		},
	};

	var allowedFunctionModuleDefinitions = [
		// Be careful which module are allowed. Otherwise the functionality may break!!!
		'modules/ScrollTo',
	];

	function validModuleDefinition(module, moduleName) {
		return typeof module === 'object' || (typeof module === 'function' && allowedFunctionModuleDefinitions.indexOf(moduleName) >= 0);
	}

	// Automatic Module Loading
	// It's possible to initialize multiple modules:
	// 1. data-module="Module1"
	// 2. data-module="Module1,Module2"
	function loadModules() {
		/* jshint validthis: true */
		var $module = $(this),
			data = $module.data(),
			moduleNames = data.module.trim().split(',')
		;

		moduleNames.forEach(function (moduleName) {
			moduleName = moduleName.trim();
			if (! /^(core)\//.test(moduleName)) {
				moduleName = 'modules/' + moduleName;
			}

			require([moduleName], function(module) {
				try {
					if (! validModuleDefinition(module, moduleName)) {
						throw new Error('Malformed module "'+ moduleName +'"!');
					}
					if (module._loadCSS !== false) {
						// Automatically load Module CSS-file
						lscss.loadModuleCSS(moduleName.replace(/^modules\//,''));
					}

					// @TODO: use "proper" Classes instead of simple objects:
					//        new Module() ...
					if (typeof module.init === 'function' && (module.autoInit || data.autoInit) !== false) {
						module.init($module);
					}
				}
				catch (ex) {
					if (_debug) {
						/* global console:true */
						console.error(moduleName, ex.stack || ex.message || ex);
					}
				}
			});

		});
	}

	function initModules(context, callback) {
		if (context === undefined) {
			throw new Error('You have to specify a context!');
		}
		var $context = $(context);
		if (initializedContexts.indexOf($context[0]) >= 0) {
			$context = null;
			throw new Error('This context has already been initialized!');
		}
		initializedContexts.push($context[0]);


		$.each(module.selectorToModule, function(selector, moduleConf) {
			var $elements = $(selector, $context);

			if ($elements.length > 0) {
				$elements.each(function() {
					var $element = $(this);

					if ($element.data('module') !== undefined) {
						if (_debug) {
							/* global console:true */
							console.warn('"data-module" has already been declared! Skipping initialization of "'+ moduleConf.moduleName +'"', $element);
						}
						return true; // continue
					}

					$element.attr('data-module', moduleConf.moduleName);
					$element.attr('data-module-priority', moduleConf.priority || 'low');
				});
			}

		});

		var $allModules = $('[data-module]', $context),
			$modulesHighPriority = $allModules.filter('[data-module-priority=high]'),
			$modulesLowPriority = $allModules.filter('[data-module-priority=low]'),
			$modules = $allModules.not('[data-module-priority=high],[data-module-priority=low]')
		;

		var promise = $.when([
			$.Deferred(function() {
				$modulesHighPriority.each(loadModules);
			}),
			$.Deferred(function() {
				$modules.each(loadModules);
			}),
			$.Deferred(function() {
				$modulesLowPriority.each(loadModules);
			}),
		]);

		// Parsley Form Validation
		promise.then(function() {
			var parsleyFormEvents = [
				'init',
				'validate',
				'success',
				'error',
				'validated',
				'submit',
			];
			var parsleyOptions = {
				excluded: '[disabled], input[type=button], input[type=submit], input[type=reset], input[type=hidden]',

				// Bootstrap classes for ParsleyJS
				//successClass: 'parsley-success has-success',
				successClass: 'parsley-success',
				errorClass: 'parsley-error has-danger',
				classHandler: function(parsleyField) {
					var $element = parsleyField.$element;
					return $element.add($element.closest('.form-group'));
				},
				errorsWrapper: '<ul class="parsley-errors-list form-control-feedback"></span>',
			};

			var $parsley = $('[data-parsley-validate]', $context);
			if ($parsley.length > 0) {
				var lang = $('html').attr('lang') || '';

				var parsleyFieldValidate = function(event) {
					var $element = this.$element,
						serverErrorRemoved = $element.data('serverErrorRemoved')
					;
					if (serverErrorRemoved !== true) {

						$element.removeClass('powermail_field_error');

						var id = $element.attr('id'),
							marker = /type-(?:text|check|radio|select)-(.+)$/gi.exec(id)
						;

						if (marker !== null) {
							marker = marker[1];

							var $errorsContainer = $('.powermail_field_error_container_'+ marker);
							if ($errorsContainer.length === 0) {

								marker = marker.split(/_(\d+)$/)[0];
								$errorsContainer = $('.powermail_field_error_container_'+ marker);
							}

							var $errorsList = $errorsContainer.find('ul.form-error--list');
							if ($errorsList.length > 0) {
								$errorsList.remove();
								$element.data('serverErrorRemoved', true);
							}
						}

					}
				};

				require(['3rdparty/parsley'], function() {
					var init = function() {
						var parsleyRef = $parsley.parsley(parsleyOptions);

						function parsleyEventBindings(parsleyInstance) {
							parsleyInstance.on('field:validate', parsleyFieldValidate);

							parsleyFormEvents.forEach(function (eventName) {
								parsleyInstance.on('form:'+ eventName, function () {
									parsleyInstance.$element.trigger('parsley:form:' + eventName, [parsleyInstance]);
								});
							});
						}

						if (Array.isArray(parsleyRef)) {
							parsleyRef.forEach(function (p) {
								parsleyEventBindings(p);
							});
						}
						else if (parsleyRef) {
							parsleyEventBindings(parsleyRef);
						}

						$parsley.find('*').filter(function (idx, elem) {

							var $this = $(this),
								data = $this.data()
							;
							$.each(data, function (key, val) {

								var match = /^parsleyCustom(.+)/.exec(key);
								if (match) {
									require(['modules/forms/parsley/'+ key], function(validator) {
										validator.init($this);
									});
									return false;
								}
							});

						});
					};

					require(['3rdparty/parsley/'+ lang], init, init);
				});
			}
		});

		// IE8, re-run Respond.js
		promise.then(function() {
			// https://github.com/scottjehl/Respond#api-options
			if (window.respond !== undefined && typeof window.respond.update === 'function') {
				window.respond.update();
			}
		});

		promise.done(function() {
			if (typeof callback === 'function') {
				callback.apply(context, [$allModules]);
			}
		});

		return promise;
	}

	function enableDebug(debug) {
		_debug = !!debug;
	}

	module.initModules = initModules;
	module.enableDebug = enableDebug;
	module.validModuleDefinition = validModuleDefinition;

	return module;
});

